import type { InsightsPayload } from "@weather-deck/shared";
import { el } from "./dom";

export function buildNotable(p: InsightsPayload): HTMLElement | null {
  const headline = p.headline;
  if (!headline) return null;

  const others = p.others;
  const children: Array<Node | null> = [
    el("div", { className: "notable-label", text: "NOTABLE" }),
    el("div", { className: "notable-headline", text: headline.headline }),
    el("p", { className: "notable-detail", text: headline.detail })
  ];

  if (others.length > 0) {
    const list = el("div", { className: "notable-others" }, others.map((o) =>
      el("div", { className: "notable-other-row" }, [
        el("div", { className: "notable-other-headline", text: o.headline }),
        el("p", { className: "notable-other-detail", text: o.detail })
      ])
    ));
    list.hidden = true;

    const toggle = el("button", { className: "notable-toggle", text: `+${others.length} more ▸` });
    toggle.addEventListener("click", () => {
      list.hidden = !list.hidden;
      toggle.textContent = `+${others.length} more ${list.hidden ? "▸" : "▾"}`;
    });

    children.push(toggle, list);
  }

  return el("section", { className: "notable" }, children);
}
